var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDocumentGrey = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.625v1.313c0 .309-.253.562-.563.562h-7.875a.564.564 0 0 1-.562-.563v-1.312c0-.31.253-.563.563-.563h7.874c.31 0 .563.254.563.563zM18.937 18h-7.875a.564.564 0 0 0-.562.563v1.312c0 .31.253.563.563.563h7.874c.31 0 .563-.254.563-.563v-1.313a.564.564 0 0 0-.563-.562zM24 9.183V24.75A2.25 2.25 0 0 1 21.75 27H8.25A2.25 2.25 0 0 1 6 24.75V5.25A2.25 2.25 0 0 1 8.25 3h9.567c.596 0 1.167.24 1.59.66l3.932 3.934c.422.417.661.994.661 1.589zm-6-3.75V9h3.567L18 5.433zm3.75 19.317v-13.5h-4.875a1.122 1.122 0 0 1-1.125-1.125V5.25h-7.5v19.5h13.5z",
    fill: "#4A606A",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDocumentGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-document-grey.5d6e74892c00b9f9f2f20c89e3aaab65.svg";